import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import Modal from "react-responsive-modal";
export default function UnpairAlertModal(props) {
    return (
        <Modal open={props.show} onClose={props.onCloseClicked}>
            <h4 style={{width: "1000px"}}> Are you sure you want to unpair the switch ?</h4>
            <Row>
                    <div style={{marginTop: 4,marginLeft:15}}>
                        Unpairing a switch will clear it's configuration, click 'Proceed' to continue.
                    </div>
            </Row>
            <Row>
                <Col sm={12}>
                <Button variant="primary" style={{margin: 20}}
                        onClick={props.onUnpairSwitch}>Proceed</Button>
                </Col>
            </Row>
        </Modal>
    )  
}